__turbopack_context__.v({
  "actions": "SaveTripPromptContent-module__yzUC4q__actions",
  "copy": "SaveTripPromptContent-module__yzUC4q__copy",
  "emailButton": "SaveTripPromptContent-module__yzUC4q__emailButton",
  "prompt": "SaveTripPromptContent-module__yzUC4q__prompt",
  "subtitle": "SaveTripPromptContent-module__yzUC4q__subtitle",
  "title": "SaveTripPromptContent-module__yzUC4q__title",
});
